const colors = {
	white: '#fff',
	black: '#000',
	ice: '#f6f6f6',
	grayDarker: '#373a3c',
	grayDark: '#2f3c4e',
	gray: '#55595c',
	grayLight: '#707879',
	grayLighter: '#ddd',
	red: '#c00',
	babyBlue: '#dcedf6',
	blue: '#4466f2',
	highlightYellow: '#ffff99',
	transparent: 'transparent',
}

export default colors
